import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// component
import {LangController} from "../../../../components/tabs/langController";

// labels
import {FL_LONG_DESCRIPTION, FL_SHORT_DESCRIPTION} from "../../../../components/i18n/formLabels";
import {PH_LONG_DESCRIPTION, PH_SHORT_DESCRIPTION} from "../../../../components/i18n/placeHolders";

const AmenitiesLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name },
            description : '',
            shortDescription  : '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_SHORT_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        name="shortDescription"
                        placeholder={PH_SHORT_DESCRIPTION}
                        value= { child.shortDescription }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md={"12"}>
                <FormGroup>
                    <Label>{FL_LONG_DESCRIPTION}</Label>
                    <Input
                        type="textarea"
                        rows="10"
                        name="description"
                        placeholder={PH_LONG_DESCRIPTION}
                        value= { child.description }
                        onChange={e => onInputChange(e, child.lang)}
                        disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
        </Row>
    </>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default AmenitiesLangs